export default {
  Loading: 'Laden',
};
